import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HtmlParser from "react-html-parser";
import { Link } from "gatsby";
import {
  SearchEngineStrategicBrand,
  SearchEngineCosEff,
  SearchEngineIntegrated,
  SearchEngineCustomerJourney,
} from "../../../app-constants-updated";

const StackItem = [
  {
    icon: SearchEngineStrategicBrand,
    title: "Strategic Brand<br/> Positioning",
    description:
      "Establish your brand authority by consistently appearing in top search results for critical, industry-specific terms, increasing credibility and trust among potential customers.",
  },
  {
    icon: SearchEngineCosEff,
    title: "Cost-Efficient<br/> Market Penetration",
    description:
      "Achieve broader market reach with targeted campaigns focusing on underserved or emerging markets, effectively growing your customer base without inflating acquisition costs.",
  },
  {
    icon: SearchEngineIntegrated,
    title: "Integrated Cross<br/> Channel Strategies",
    description:
      "Amplify your SEM efforts by synchronizing with social media, email marketing, and display advertising—a unified approach to drive consistent messaging and engagement across all touchpoints.",
  },
  {
    icon: SearchEngineCustomerJourney,
    title: "Customer<br/> Journey Mapping",
    description:
      "Use SEM data to map the customer journey, identify critical touchpoints where targeted ads influence decision-making, and guide prospects seamlessly from awareness to purchase.",
  },
];

function Purposeweb() {
  return (
    <div className="technoloy_sec digital_why_choose search-engine-query p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Get Noticed on Every Relevant <span>Search Query</span>
            </h2>
            <p>
              Increase your chances of winning more valuable clicks with our
              high-impact search engine marketing services.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto">
            <div className="technology_main web_purpose_text">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon web_text">{item.icon}</div>
                  <h6>{HtmlParser(item.title)}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-3 mt-md-5 text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Rank in Top Search Results
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Purposeweb;
